import axios from "axios"
import cookie from "react-cookies"
import { secureIdHeadersFromValue } from "services/secureIdHeaderUtils"

const baseUrlV2 = `${process.env.REACT_APP_API_BASE_URL}/v2.0`

const getSecureIdHeaders = () => {
  const secureId = cookie.load("blink_agent_secureId") || cookie.load("secureId") || ""
  return secureIdHeadersFromValue(secureId)
}

export const getAllReferralsAPI = (payload) => axios
  .post(`${baseUrlV2}/referral-transactions`, payload)

export const createReferralAPI = (payload) => axios
  .post(`${baseUrlV2}/add-referral`, payload, { headers: getSecureIdHeaders() })

export const getReferralDetailsAPI = (referralId, agentId) => {
  const query = agentId ? `?agent_id=${agentId}` : ""
  return axios.get(
    `${baseUrlV2}/referral-cover/${referralId}/all_referral_information${query}`,
    { headers: getSecureIdHeaders() },
  )
}

export const updateReferralCoverAPI = (referralId, payload) => axios
  .put(`${baseUrlV2}/referral-cover/${referralId}`, payload)

export const updateReferralStatusAPI = (payload) => axios
  .post(`${baseUrlV2}/referral-status-update`, payload, { headers: getSecureIdHeaders() })
